import { Types } from "../../../../rpcs/dist/EpisodeRPC"

export const EditableTypes = [
  Types.Message,
  Types.Annotation,
  Types.Introduction,
  Types.Pickup,
  Types.Headline,
  Types.Quotation,
  Types.Survey,
]
